import { render } from "./ElementLoading.vue?vue&type=template&id=f64bfd60"
import script from "./ElementLoading.vue?vue&type=script&lang=js"
export * from "./ElementLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/loaders/ElementLoading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f64bfd60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f64bfd60', __exports__)) {
    api.reload('f64bfd60', __exports__)
  }
  
  module.hot.accept("./ElementLoading.vue?vue&type=template&id=f64bfd60", () => {
    api.rerender('f64bfd60', render)
  })

}


export default __exports__